// extracted by mini-css-extract-plugin
export default {"block_titles":"BlockTitle_block_titles__otmAa"};